exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notshippingmethods[data-v-75a6bfa6] {\n  padding: 15px 63px;\n  text-align: center;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n}\n.notshippingmethods svg[data-v-75a6bfa6] {\n  width: 64px;\n}\n.notshippingmethods p[data-v-75a6bfa6] {\n  margin: 0;\n  padding-top: 15px;\n  color: #545454;\n  font-size: 14px;\n}", ""]);

// exports
